export default __webpack_public_path__ + "static/media/wand-prep.c4d1f067.webp";